var render = function render(){var _vm=this,_c=_vm._self._c;return _c('thead',[_c('tr',[(_vm.selectAll)?_c('th'):_vm._e(),_vm._l((_vm.cloumns),function(cloumn){return [(!cloumn.disable)?_c('tableTh',{class:cloumn.supData ? 'sup_data' : '',attrs:{"text":cloumn.title,"sort":cloumn.sort ? cloumn.column : null}}):_vm._e()]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }